const REGEX_PATTERN_ACCEPTED_CHARS = /^[A-zÀ-ÿĀ-Ūā-ū0-9-'(). ]+$/;

/**
 * @name noSpecialCharacters
 * @description Validates a value against a series of alpha numeric chars and acceptable punctuation
 */
export const noSpecialCharacters = {
  test: ({ value }: any) =>
    Boolean(value) === false || REGEX_PATTERN_ACCEPTED_CHARS.test(value),
  getErrorMessage: () =>
    Promise.resolve(
      'Invalid characters were entered. Use alpha numeric characters only',
    ),
};

/**
 * @name isValidSsoEmail
 * @description Validates an email address against validation rules set by Auth0
 * https://auth0.com/docs/user-profile#create-a-new-user
 */
export const isValidSsoEmail = {
  test: ({ value }: any) => {
    if (value.includes('@')) {
      const emailParts = value.split('@');
      const emailUser = emailParts[0];
      const emailDomain = emailParts[1];

      return (
        Boolean(value) === false ||
        (emailUser.length <= 64 && emailDomain.length <= 256)
      );
    }

    return false;
  },
  getErrorMessage: () =>
    Promise.resolve(
      'Invalid email address. The user portion must be fewer than 65 characters.',
    ),
};
